/**
 * Created by tiedong on 2017/8/19.
 */
import { handleActions } from 'redux-actions'
import * as types from '../constants/ActionTypes'
const reducers = {}
const initialState = {
   roleList:[]

}

reducers[types.CREATE_ROLE_FINISH] = {
    next(state, action) {
        return Object.assign({}, state, {
            roleList: action.payload.result
        })
    },
    throw(state,action){
        return Object.assign({}, state, {loadError: true})
    }
}

reducers[types.UPDATE_ROLE_START] = (state, action) => {
    return Object.assign({}, state, {updateRoleStart: true})
}

reducers[types.DELETE_ROLE_START] = (state, action) => {
    return Object.assign({}, state, {deleteRoleStart: true})
}


export default handleActions(reducers, initialState)